export default {"src":"/_next/static/media/easier-1.8be0847f.svg","height":54,"width":47,"blurWidth":0,"blurHeight":0};